<!-- OrderDetailBody.vue -->
<template>
  <div>
    <div class="common-header-wrap">
      <mt-header title="订单详情" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="order-body" v-if="order_info">
      <div class="order_state">
        <i class="iconfont" v-if="order_info.order_state == '40'">&#xe61b;</i>
        <i class="iconfont" v-else>&#xe61a;</i>
        <span>{{ order_info.order_state_show }}</span>
      </div>
      <!-- 退款信息 -->
      <div class="refund-card" v-if="refund_info">
        <div class="refund-head">
          <i class="iconfont">&#xe62d;</i>
          <span>退款信息</span>
          <b class="refund-state">{{refund_info.refund_state_show}}</b>
        </div>
        <div class="refund-row">
          <span>申请时间</span>
          <b>{{refund_info.add_time}}</b>
        </div>
        <div class="refund-row">
          <span>退款金额</span>
          <b class="refund-amount">￥{{refund_info.refund_amount}}</b>
        </div>
        <div class="refund-row">
          <span>退款原因</span>
          <b>{{refund_info.buyer_message}}</b>
        </div>
        <div class="refund-row">
          <span>商户审核时间</span>
          <b>{{refund_info.seller_time}}</b>
        </div>
        <div class="refund-row">
          <span>商户审核备注</span>
          <b>{{refund_info.seller_message}}</b>
        </div>
         <div class="refund-row">
          <span>管理员审核时间</span>
          <b>{{refund_info.admin_time}}</b>
        </div>
        <div class="refund-row">
          <span>管理员审核备注</span>
          <b>{{refund_info.admin_message}}</b>
        </div>
      </div>


      <div class="address">
        <div>
          <span>{{ order_info.reciver_name }}</span>
          <span class="mobile">{{ order_info.reciver_phone }}</span>
        </div>
        <p style="-webkit-box-orient: vertical; -webkit-line-clamp: 2">
          {{ order_info.reciver_addr }}
        </p>
      </div>

      <div class="order_store" v-if="order_info.extend_store">
        <i class="store iconfont">&#xe62d;</i
        ><span>{{ order_info.extend_store.store_name }}</span>
      </div>

      <div
        class="containers"
        v-for="item in order_info.goods_list"
        v-bind:key="item.goods_id"
      >
        <img class="photo" v-bind:src="item.image_url" />
        <div class="right-wrapper">
          <label class="title">{{ item.goods_name }}</label>
          <label class="property">{{ item.goods_spec }}</label>
          <div class="desc-wrapper">
            <div>
              <label class="price">￥ {{ item.goods_price }}</label>
              <label class="count">x{{ item.goods_num }}</label>
            </div>
            <div class="btn-list">
              <mt-button
                v-if="item.refund == '1'"
                plain
                size="small"
                @click.stop="showRefund(item.rec_id)"
                >售后</mt-button
              >
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="order_info.zengpin_list"
        class="containers"
        v-for="item in order_info.zengpin_list"
        v-bind:key="item.goods_id"
      >
        <img class="photo" v-bind:src="item.image_url" />
        <div class="right-wrapper">
          <label class="title"
            ><span class="tag-icon">赠品</span>{{ item.goods_name }}</label
          >
          <label class="property">{{ item.goods_spec }}</label>
          <div class="desc-wrapper">
            <div>
              <label class="price">￥ {{ item.goods_price }}</label>
              <label class="count">x{{ item.goods_num }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="detail">
        <div class="number">
          <label>订单编号：{{ order_info.order_sn }} </label>
          <p>下单时间：{{ order_info.add_time }}</p>
        </div>
        <div class="pay" v-if="order_info.payment_name">
          <p>支付方式：{{ order_info.payment_name }}</p>
        </div>
      </div>
      <!-- 发货信息 -->
      <div class="refund-card" v-if="order_info.is_fahuo">
        <div class="refund-head">
          <i class="iconfont">&#xe62d;</i>
          <span>快递名称</span>
          <b class="refund-state">{{order_info.express_name}}</b>
          <button class="btn-logistics" @click="lookLogistics">查看物流</button>
        </div>
        <div class="refund-row">
          <span>快递单号</span>
          <b>{{order_info.shipping_code}}</b>
        </div>
      </div>
      <div style="margin-bottom: 120px">
        <div class="desc section-header section-footer">
          <div class="container">
            <label class="title">商品总额</label>
            <label class="subtitle">￥{{ order_info.goods_amount }}</label>
          </div>
          <div class="container">
            <label class="title">运费</label>
            <label class="subtitle">￥{{ order_info.shipping_fee }}</label>
          </div>
          <div
            class="container"
            v-if="order_info.promotion && order_info.promotion.length > 0"
          >
            <label class="title">优惠</label>
            <label
              class="subtitle"
              v-for="(p, i) in order_info.promotion"
              v-bind:key="i"
              >{{ p[1] }}</label
            >
          </div>
          <label class="amount"
            >实付款 : <span> ￥{{ order_info.order_amount }}</span>
          </label>
          <div class="order-list-opratio">
            <button v-on:click="cancel()" v-if="order_info.order_state == 20">
              申请退款
            </button>
            <button class="line_red" @click="handlePay()" v-if="order_info.order_state == 10">
              去支付
            </button>
            <button class="line_red" @click="handleReceive()" v-if="order_info.if_receive">
              确认收货
            </button>
          </div>
        </div>
      </div>
    </div>
          <!-- 物流信息弹窗 -->
      <div class="express-mask" v-if="expressModalVisible" @click.self="closeExpress">
        <div class="express-sheet">
          <div class="express-head">
            <h3>物流信息</h3>
            <button class="express-close" @click="closeExpress">×</button>
          </div>
          <div class="express-meta">
            <div class="row">
              <span>快递名称</span>
              <b>{{ expressData.express_name }}</b>
            </div>
            <div class="row">
              <span>快递单号</span>
              <b>{{ expressData.shipping_code }}</b>
            </div>
          </div>
          <div class="express-tracks" v-if="expressData.list && expressData.list.length">
            <div
              class="track"
              v-for="(t, i) in expressTracks()"
              v-bind:key="i"
              :class="{ first: i === 0 }"
            >
              <div class="track-dot"></div>
              <div class="track-body">
                <p class="track-context">{{ t.context }}</p>
                <p class="track-time">{{ t.ftime }}</p>
              </div>
            </div>
          </div>
          <div class="express-empty" v-else>暂无物流轨迹</div>
        </div>
      </div>
    </div>
  
  
</template>

<script>
import { Toast, Indicator, MessageBox } from "mint-ui";
import { qyorderdetail, qybuypay, qyorderrefund,qyorderexpress,qyordershouhuo} from "../../api/uniqyOrderH5";
export default {
  name: "MemberOrderDetail",
  data() {
    return {
      order_info: {},
      refund_info:null,//退款信息
      expressData: {}, // 物流信息
      expressModalVisible: false, // 物流弹窗显示状态
      rec_id: 0,
      popupRefund: false,
      orderId: this.$route.query.orderId ? this.$route.query.orderId : 0, //从路由中获取变量
    };
  },
  created: function () {
    this.initialize();
  },
  methods: {
    async handleReceive(){//确认收货
      
      Indicator.open({ text: "数据请求中..." });
      try {
        let res = await qyordershouhuo(
          this.order_info.order_id,
          this.order_info.buyer_id,
          this.order_info.buyer_name
        );
        Indicator.close();
        if (res.data.code == "10001") {
          Toast(res.data.message || "请求失败");
          return false;
        }
        else{
           Toast("操作成功");
           this.initialize();//刷新数据
        }
      } catch (e) {
        Indicator.close();
        Toast("网络异常，请稍后重试");
      }
    },
    async initialize() {
      Indicator.open();
      let res = await qyorderdetail(this.orderId);
      Indicator.close();
      if (res.data.code == "10001") {
        Toast(res.data.message);
        setTimeout(() => {
          window.location.href = "/home/index";
        }, 1000);
      } else {
        //console.log(res);
        this.order_info = res.data.result.order_info;
        this.refund_info = res.data.result.refund_info;
      
      }
    },
    async handlePay() {
      //判断时间,支付之前判断时间是否超时
      const orderTime = this.order_info.add_time; // 下单时间
      const orderTimestamp = new Date(orderTime).getTime();
      const nowTimestamp = Date.now();
      const fifteenMinutes = 15 * 60 * 1000;
      let that = this;
      if (nowTimestamp - orderTimestamp > fifteenMinutes) {
        Toast("该订单已超时,不能支付系统会自动取消,即将返回权益平台");
        setTimeout(() => {
          window.location.href = that.order_info.qbackUrl;
        }, 2000);
      } else {
        //未超时发起支付
        Indicator.open({ text: "数据载入中..." });
        let res = await qybuypay(
          that.order_info.pay_sn,
          that.order_info.buyer_id
        );
        Indicator.close();
        if (res.data.code == "10000") {
          window.location.href = res.data.result;
          return;
        } else {
          Toast(res.data.message);
          return false;
        }
      }
    },
    showRefund(rec_id) {
      Toast("请拨打400-998-9999客服电话,申请售后");
      return false;
    },
    complaint(order_id, goods_id) {
      this.$router.push({
        name: "MemberComplaintForm",
        query: { order_id: order_id, goods_id: goods_id },
      });
    },
    cancel() {
      //申请退款
      var that = this;
      MessageBox.confirm(
        "确定要申请退款吗？退款申请提交后，请留意退款进度。",
        "申请退款",
        {
          confirmButtonText: "确定",
          cancelButtonText: "再想想",
        }
      )
        .then(function (action) {
          that.doRefund();
        })
        .catch(function () {
          // 用户点了取消，不做任何操作
        });
    },
    async doRefund() {
      let that = this;
      Indicator.open();
      let res = await qyorderrefund(this.order_info.order_id,that.order_info.buyer_id);
      Indicator.close();
      if (res.data.code == "10001") {
        Toast(res.data.message);
        this.initialize();
      } else {
        Toast(res.data.message); 
      }
    },
    async lookLogistics(){//查看物流方法
        //查看物流：调用后端接口查询轨迹，弹窗展示
      var code = this.order_info.shipping_code;
      if (!code) {
        Toast("暂无物流单号");
        return false;
      }
      Indicator.open({ text: "物流查询中..." });
      try {
        let res = await qyorderexpress(
          this.order_info.shipping_code,
          this.order_info.express_name,
          this.order_info.order_sn
        );
        Indicator.close();
        if (res.data.code == "10001") {
          Toast(res.data.message || "物流信息查询失败");
          return false;
        }
        
        var r = res.data.result || {};
        this.expressData = {
          express_name: r.express_name || this.order_info.express_name || "",
          shipping_code: r.shipping_code || this.order_info.shipping_code || "",
          list: r.list || [],
        };
        this.expressModalVisible = true;
      } catch (e) {
        Indicator.close();
        Toast("网络异常，请稍后重试");
      }
    },
    closeExpress() {
      this.expressModalVisible = false;
    },
    expressTracks() {
      // 轨迹默认最新一条在最上面（接口若已倒序，去掉 reverse 即可）
      var list = (this.expressData.list || []).slice();
      return list;
    },
  },
};
</script>
<style lang="scss" scoped>
.express-mask {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.express-sheet {
  width: 100%;
  max-height: 80vh;
  background: #fff;
  border-radius: 1rem 1rem 0 0;
  padding: 0.8rem 1rem 1rem;
  overflow-y: auto;
}
.express-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.6rem;
  border-bottom: 1px solid #f5f5f5;
  h3 {
    font-size: 0.85rem;
    color: #333;
  }
  .express-close {
    font-size: 1.2rem;
    color: #999;
    width: 1.6rem;
    height: 1.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.express-meta {
  padding: 0.6rem 0;
  border-bottom: 1px solid #f5f5f5;
  .row {
    display: flex;
    font-size: 0.7rem;
    padding: 0.15rem 0;
    span {
      color: #7c7f88;
      width: 4rem;
      flex: none;
    }
    b {
      color: #333;
      font-weight: 500;
    }
  }
}
.express-tracks {
  padding: 0.6rem 0 0.2rem;
}
.track {
  position: relative;
  display: flex;
  padding-bottom: 0.9rem;
  .track-dot {
    flex: none;
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
    background: #ccc;
    margin: 0.25rem 0.6rem 0 0;
  }
  &.first .track-dot {
    background: #e93b3d;
  }
  .track-body {
    flex: 1;
    min-width: 0;
  }
  .track-context {
    font-size: 0.7rem;
    color: #333;
    line-height: 1.5;
  }
  .track-time {
    font-size: 0.6rem;
    color: #999;
    margin-top: 0.15rem;
  }
}
.express-empty {
  text-align: center;
  padding: 1.5rem 0;
  font-size: 0.7rem;
  color: #999;
}

.btn-logistics {
  flex: none;
  margin-left: 0.5rem;
  padding: 0.15rem 0.5rem;
  font-size: 0.65rem;
  color: #e93b3d;
  background: #fff;
  border: 1px solid #e93b3d;
  border-radius: 0.7rem;
  box-shadow: 0 2px 5px 0 rgba(233, 59, 61, 0.1);
}

.order-body {
  overflow: auto;
  height: 100%;
  position: absolute;
  width: 100%;
  .desc {
    .container {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      background-color: #fff;
    }
    .title {
      width: 5rem;
      font-size: 0.7rem;
      color: #333;
      margin-left: 0.6rem;
    }
    .subtitle {
      flex: 1;
      margin-left: 1rem;
      margin-right: 0.6rem;
      color: $primaryColor;
      font-size: 0.7rem;
      text-align: right;
    }
  }
}
.order_state {
  background: #e93b3d;
  height: 3.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  i {
    color: #fff;
    font-size: 1.2rem;
    padding: 0 0.5rem;
  }
  span {
    font-size: 0.8rem;
    color: #fff;
  }
}
.containers {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  background-color: #fff;
  border-bottom: 1px solid #e8eaed;
}
.photo {
  width: 4rem;
  height: 4rem;
  margin: 0.75rem 0.5rem 0.75rem 0.75rem;
  border: 1px solid #e8eaed;
  flex-basis: 4rem;
  flex-shrink: 0;
}
.right-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 0 0.75rem 0 0;
  width: 100%;
  overflow: hidden;
}
.title {
  margin-top: 0.75rem;
  color: #333;
  font-size: 0.7rem;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.property {
  font-size: 0.65rem;
  color: #7c7f88;
  padding-top: 0.5rem;
}
.count {
  margin-top: 0.2rem;
  color: #7c7f88;
  font-size: 0.65rem;
  margin-right: 0.5rem;
}
.desc-wrapper {
  height: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
}
.price {
  color: $primaryColor;
  font-size: 0.8rem;
  margin-left: 0;
}
.count {
  color: #7c7f88;
  font-size: 0.8rem;
  margin-left: 0.5rem;
}
.address {
  height: 4.4rem;
  background-color: #fff;
  margin-bottom: 0.5rem;
  div {
    padding: 0.5rem 0.5rem 0;
  }
  img {
    height: 0.8rem;
  }
  span {
    color: #333;
    font-size: 0.8rem;
    &.mobile {
      padding-left: 1rem;
    }
  }
  p {
    margin: 0.25rem 0.9rem 0.5rem 0.5rem;
    font-size: 0.7rem;
    color: #7c7f88;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}

.contact {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 2.3rem;
  background-color: #fff;
  margin-top: 0.4rem;
  border-bottom: 1px solid #e8eaed;
  padding: 0 0.65rem;
  span {
    font-size: 0.6rem;
    color: #333;
    padding-right: 0.3rem;
  }
  img {
    width: 0.6rem;
    height: 0.65rem;
  }
}

.detail {
  display: flex;
  flex-direction: column;
  font-size: 0.7rem;
  color: #7c7f88;
  background-color: #fff;
  margin: 0.4rem 0;
  box-sizing: border-box;
  .number {
    padding: 0.7rem 0.8rem;
    border-bottom: 1px solid #e8eaed;
    p {
      padding-top: 0.3rem;
      font-size: 0.7rem;
    }
    button {
      color: #7c7f88;
      height: 1rem;
      background-color: #fff;
      border: 1px solid #7c7f88;
      width: 2.7rem;
      height: 1rem;
      border-radius: 0.1rem;
      font-size: 0.7rem;
    }
  }
  .pay {
    border-bottom: 1px solid #e8eaed;
    padding: 0.7rem 0.8rem;
  }
  .givetime {
    padding: 0.7rem 0.8rem;
    font-size: 0.7rem;
  }
  input {
    background-color: #fff;
    border: 1px solid #7c7f88;
  }
}
.desc {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding-top: 0.6rem;
  box-sizing: border-box;
  margin-bottom: 4rem;
  .desc-item {
    flex: 1;
    margin-top: 0.5rem;
  }
  .amount {
    display: flex;
    justify-content: flex-end;
    font-size: 0.7rem;
    color: #333;
    padding-right: 0.75rem;
    border-top: 1px solid #e8eaed;
    margin-top: 0.6rem;
    height: 2.2rem;
    line-height: 2.2rem;
    span {
      font-size: 0.8rem;
      color: $primaryColor;
    }
  }
}
.ship {
  margin-bottom: 0;
}
.order_store {
  background: #fff;
  height: 1rem;
  line-height: 1rem;
  padding: 0.5rem 0.8rem;
  border-bottom: 1px solid #f5f5f5;
}
.order_store span {
  color: #333;
  font-size: 0.7rem;
  font-weight: 600;
  float: left;
  margin: 0 0.4rem;
}
.order_store i.store {
  float: left;
}
.order_store i.more {
  float: left;
  font-size: 0.7rem;
}
.order-list-opratio {
  text-align: right;
  position: fixed;
  bottom: 51px;
  left: 0;
  width: 100%;
  background: #fff;
  border-top: 1px solid #efefef;
}
.order-list-opratio button {
  width: 4.5rem;
  height: 1.5rem;
  font-size: 0.7rem;
  border-radius: 0.7rem;
  margin: 0.35rem 0.75rem 0.35rem 0;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.05);
}
.order-list-opratio .line_red {
  background-color: #fff;
  color: #f2270c;
  border: 1px solid #f2270c;
  box-shadow: 0 3px 6px 0 rgba(242, 39, 12, 0.1);
}
.refund-card {
  background: #fff;
  margin-bottom: 0.5rem;
  padding: 0.6rem 0.8rem;
  .refund-head {
    display: flex;
    align-items: center;
    padding-bottom: 0.4rem;
    border-bottom: 1px solid #f5f5f5;
    span {
      font-size: 0.75rem;
      font-weight: 600;
      color: #333;
      margin-left: 0.3rem;
      flex: 1;
    }
    .refund-state {
      font-size: 0.7rem;
      color: #e93b3d;
    }
  }
  .refund-row {
    display: flex;
    justify-content: space-between;
    padding-top: 0.35rem;
    font-size: 0.7rem;
    span { color: #7c7f88; }
    b {
      color: #333;
      font-weight: 500;
      text-align: right;
    }
    .refund-amount { color: $primaryColor; font-weight: 700; }
  }
}
</style>

<!-- 字体图标样式覆盖 -->
<style>
.mint-toast-icon {
  font-size: 1.9rem;
}
button {
  padding: 0;
}

</style>
